import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import RetouchingPage from './RetouchingPage';
import BeautifyPage from './BeautifyPage';
import EnhancePage from './EnhancePage';
import SegmentedControl from '../components/SegmentedControl';

const HomePage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('retouching');

  const tabs = [
    { id: 'retouching', component: RetouchingPage },
    { id: 'beautify', component: BeautifyPage },
    { id: 'enhance', component: EnhancePage }
  ];

  const activeComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="min-h-screen bg-white">
      {/* 子导航栏（保留代码但不展示） */}
      <div className="hidden pt-6 pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center">
            <SegmentedControl
              items={tabs.map(tab => ({ id: tab.id, label: t(`navigation.${tab.id}`) }))}
              value={activeTab}
              onChange={setActiveTab}
            />
          </div>
        </div>
      </div>

      {/* 纵向分区：统一间距（顶部、底部与分区间距一致） */}
      <div className="space-y-1 md:space-y-3 lg:space-y-5 pt-1 md:pt-3 lg:pt-5 pb-1 md:pb-3 lg:pb-5">
        {/* Section 1: Beautify - 深色底（交换后首屏保持深色） */}
        <section className="bg-neutral-950 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-10">
            <BeautifyPage variant="dark" />
          </div>
        </section>

        {/* Section 2: Retouching - 浅色 */}
        <section className="bg-[rgb(245,245,247)]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-10">
            <RetouchingPage variant="light" />
          </div>
        </section>

        {/* Section 3: Enhance - 浅色 */}
        <section className="bg-[rgb(245,245,247)]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-10">
            <EnhancePage variant="light" />
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomePage;